import axios from "../utils/ajaxRequest";

export const heartRate = (params) => axios.request({url: '/share/heartRate', method: 'POST', data: params});
export const bloodPressure = (params) => axios.request({url: '/share/bloodPressure', method: 'POST', data: params});
export const bloodOxygen = (params) => axios.request({url: '/share/bloodOxygen', method: 'POST', data: params});
export const bloodSugar = (params) => axios.request({url: '/share/bloodSugar', method: 'POST', data: params});
export const motion = (params) => axios.request({url: '/share/motion', method: 'POST', data: params});
export const dailyPaper = (params) => axios.request({url: '/share/dailyPaper', method: 'POST', data: params});
export const weeklyPaper = (params) => axios.request({url: '/share/weeklyPaper', method: 'POST', data: params});

export default {};